module.exports = __webpack_public_path__ + "img/0컷배치예시.9502e45e.jpg";